import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {   
      return new Promise( resolve => {
        Auth.currentAuthenticatedUser()
          .then(user => {
            if(user) {
              resolve(true);
            } else {
              console.log('AuthGuard: No authenticated user, redirecting to signin');
              this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
              resolve(false);
            }
          })          
          .catch((error) => {
            console.log('AuthGuard: Authentication check failed:', error.message);
            
            // DEBUG: Check what's in localStorage for SSO tokens
            console.log('AuthGuard: Checking localStorage for SSO tokens...');
            const localStorageKeys = Object.keys(localStorage).filter(key => 
              key.includes('CognitoIdentityServiceProvider') || key.includes('amplify')
            );
            console.log('AuthGuard: Found localStorage keys:', localStorageKeys);
            
            // Check for specific Cognito tokens
            const cognitoKeys = Object.keys(localStorage).filter(key => 
              key.includes('CognitoIdentityServiceProvider') && 
              (key.includes('.idToken') || key.includes('.accessToken') || key.includes('LastAuthUser'))
            );
            console.log('AuthGuard: Found Cognito token keys:', cognitoKeys);
            
            if (cognitoKeys.length > 0) {
              console.log('AuthGuard: SSO tokens exist in localStorage but Amplify cannot restore them');
              // Try to give Amplify time to restore the session
              console.log('AuthGuard: Attempting session restoration with delay...');
              setTimeout(async () => {
                try {
                  const restoredUser = await Auth.currentAuthenticatedUser();
                  console.log('AuthGuard: Session restored after delay:', restoredUser?.username);
                  resolve(true);
                  return;
                } catch (restoreError) {
                  console.log('AuthGuard: Session restoration failed after delay:', restoreError instanceof Error ? restoreError.message : restoreError);
                  this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
                  resolve(false);
                }
              }, 2000); // Give more time for session restoration
              return;
            }
            
            this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
            resolve(false);
          });
      });
  }
  
}
